import { render } from "./ImageCreate.vue?vue&type=template&id=c8f86636"
import script from "./ImageCreate.vue?vue&type=script&lang=js"
export * from "./ImageCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__